<template>
  <div class="people-box">
    <div class="title">
      <img :src="icon">
      {{ title }}
    </div>
    <div v-for="item in list" :key="item.id" class="people">
      <img :src="baseURL+'/'+item.photo" :style="'width: '+imgWidth" :class="{'pointer':item.filePath}" :title="item.filePath?'点击查看PDF介绍':''" @click="clickImg(item)">
      <div class="right">
        <div class="name">{{ item.name }}</div>
        <template v-if="item.title">
          <div v-for="pos in item.title.split(',')" :key="pos" class="position">
            <div>{{ pos }}</div>
          </div>
        </template>
        <div class="intro">{{ item.intro }}</div>
        <div class="email">Email: {{ item.email }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PIBox',
  props: {
    title: String,
    list: Array,
    icon: String,
    imgWidth: {
      type: String,
      default: '25.6%'
    }
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_BASE_API
    }
  },
  methods: {
    clickImg(item) {
      if (item.filePath) {
        window.open(this.baseURL + '/' + item.filePath, '_blank')
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.people-box
  margin-top 40px

  .title
    display flex
    align-items center
    margin-bottom 20px
    font-size 22px
    font-weight 600
    color rgba(31, 46, 65, 1)

    img
      margin 0 10px 0 13px
      width 30px
      height 30px

  .people
    font-size 14px
    color rgba(158,159,175,1)
    display flex
    align-items center
    margin-bottom 12px
    padding 30px 55px
    background white
    box-shadow 0 2px 4px 0 rgba(231, 234, 237, 0.5)
    border-radius 8px

    img
      margin-right 35px

    .name
      font-weight 600
      color rgba(58, 58, 58, 1)
      font-size 18px
    .intro
      white-space pre-wrap
      margin-top 20px
    .email
      margin-top 20px
      font-weight 500
      color rgba(31,46,65,1)
.pointer
  cursor pointer
</style>
